(function () {
  if (window.__ND_GBG_PATTERN_STYLE_TOGGLE__) return;
  window.__ND_GBG_PATTERN_STYLE_TOGGLE__ = true;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {

    var PATTERN_CONFIGS = [
      { patternLabel: 'GBG Pattern',  styleLabel: 'GBG Pattern Style'  },
      { patternLabel: 'Grid Pattern', styleLabel: 'Grid Pattern Style' }
    ];

    function getInputInWrapper(wrapper) {
      if (!wrapper) return null;
      return wrapper.querySelector('input[type="checkbox"], input[type="radio"]');
    }

    function showWrapper(wrapper) {
      if (!wrapper) return;
      wrapper.style.display = '';
    }

    function hideWrapper(wrapper, uncheck) {
      if (!wrapper) return;
      wrapper.style.display = 'none';
      if (uncheck) {
        var input = getInputInWrapper(wrapper);
        if (input) input.checked = false;
      }
    }

    // 對單一 Pattern 區塊做處理（GBG or Grid）
    function setupForTextarea(textarea, config) {
      if (!textarea || textarea.__ND_GBG_BOUND__) return;
      textarea.__ND_GBG_BOUND__ = true;

      var patternStack = textarea.closest('.po-stack');
      if (!patternStack) return;

      // 往後找含有「XXX Pattern Style」文字的 stack
      var styleStack = null;
      var s = patternStack.nextElementSibling;
      while (s) {
        if ((s.textContent || '').indexOf(config.styleLabel) !== -1) {
          styleStack = s;
          break;
        }
        s = s.nextElementSibling;
      }
      if (!styleStack) return;

      // 在這個 styleStack 裡用 label 抓 4 Lite Tall / 9 Lite Prairie 各自 checkbox 容器
      function findOptionWrapper(labelText) {
  var labels = styleStack.querySelectorAll('label');

  for (var i = 0; i < labels.length; i++) {
    var lbl = labels[i];

    if (!lbl.textContent) continue;
    if (lbl.textContent.indexOf(labelText) === -1) continue;

    var input =
      lbl.querySelector('input[type="checkbox"], input[type="radio"]') ||
      (lbl.htmlFor ? document.getElementById(lbl.htmlFor) : null);

    if (!input) {
      input = lbl.closest('.po-option--checkbox-wrapper, .po-option--checkbox')
        ?.querySelector('input[type="checkbox"], input[type="radio"]');
    }

    var wrapper =
      input?.closest(
        '.po-option--checkbox-wrapper,' +
        '.po-option--swatch-wrapper,' +
        '.po-swatch-wrapper,' +
        '.po-option--swatch,' +
        '.po-option__row,' +
        '.po-option__checkbox,' +
        '.po-option__radio'
      ) ||
      lbl.closest('.po-option--checkbox-wrapper') ||
      lbl.closest('.po-option--checkbox') ||
      lbl.parentElement;

    /*
     * OPTIS 有時會在 value 外面再包一層 layout cell。
     * 往外找，但只能吃掉「只包含這一個 checkbox/radio」的容器，
     * 避免把整個 Pattern Style group 隱藏。
     */
    if (input && wrapper) {
      var stack = input.closest('.po-stack');
      var candidate = wrapper;
      var parent = candidate.parentElement;
      var depth = 0;

      while (parent && parent !== stack && depth < 6) {
        var controls = parent.querySelectorAll(
          'input[type="checkbox"], input[type="radio"]'
        );

        if (controls.length === 1 && controls[0] === input) {
          candidate = parent;
          parent = parent.parentElement;
          depth++;
        } else {
          break;
        }
      }

      wrapper = candidate;
    }

    if (wrapper) return wrapper;
  }

  return null;
}

      var opt4 = findOptionWrapper('4 Lite Tall');
      var opt9 = findOptionWrapper('9 Lite Prairie');
      if (!opt4 && !opt9) return;

      function updatePatternStyles() {
        var v = (textarea.value || '').toLowerCase();
        // "2 W x 3 H" ⇒ "2wx3h"
        var norm = v.replace(/\s+/g, '');

        var is2x2 = norm.indexOf('2wx2h') !== -1 || norm.indexOf('2x2') !== -1;
        var is3x3 = norm.indexOf('3wx3h') !== -1 || norm.indexOf('3x3') !== -1;

        if (is2x2 && !is3x3) {
          // 2W x 2H：只顯示 4 Lite Tall
          if (opt4) showWrapper(opt4);
          if (opt9) hideWrapper(opt9, true);
        } else if (is3x3 && !is2x2) {
          // 3W x 3H：只顯示 9 Lite Prairie
          if (opt9) showWrapper(opt9);
          if (opt4) hideWrapper(opt4, true);
        } else {
          // 其他尺寸：兩個都隱藏
          if (opt4) hideWrapper(opt4, true);
          if (opt9) hideWrapper(opt9, true);
        }
      }

      textarea.addEventListener('input', updatePatternStyles);
      textarea.addEventListener('change', updatePatternStyles);

      setInterval(updatePatternStyles, 1000); // 防止 Optis 背後改值沒觸發事件
      updatePatternStyles();                  // 進頁面先跑一次
    }

    function findConfigByOnchange(onchangeStr) {
      for (var i = 0; i < PATTERN_CONFIGS.length; i++) {
        var cfg = PATTERN_CONFIGS[i];
        if (onchangeStr.indexOf(cfg.patternLabel) !== -1) {
          return cfg;
        }
      }
      return null;
    }

    // 掃描所有 Pattern 的 textarea（GBG + Grid）
    function scanAndSetup() {
      var tas = document.querySelectorAll('textarea.po-option--type-text');
      for (var i = 0; i < tas.length; i++) {
        var ta = tas[i];
        var oc = ta.getAttribute('onchange') || '';
        var cfg = findConfigByOnchange(oc);
        if (cfg) {
          setupForTextarea(ta, cfg);
        }
      }
    }

    // 一開始掃一次，之後每秒掃一次（應付動態載入）
    scanAndSetup();
    setInterval(scanAndSetup, 1000);
  });
})();
